import { render, staticRenderFns } from "./associatedMedia.vue?vue&type=template&id=c0dcb186&scoped=true&"
import script from "./associatedMedia.vue?vue&type=script&lang=js&"
export * from "./associatedMedia.vue?vue&type=script&lang=js&"
import style0 from "./associatedMedia.vue?vue&type=style&index=0&id=c0dcb186&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0dcb186",
  null
  
)

export default component.exports